// @flow
import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { Base, Svg } from '@gandi/ui';

import styles from './OfferBox.scss';

type Props = {
  translator: TranslatorProps,
};

function OfferBox({ translator: { __ } }: Props) {
  return (
    <Base padding="small" backgroundColor="anthracite" marginBottom="small">
      <Base
        tagName="h3"
        size="base"
        flex
        flexAlignItemsCenter
        marginBottom="small"
      >
        <Svg name="domain" className={styles.icon} />
        <Base
          tagName="span"
          transform="uppercase"
          backgroundColor="promotional"
          marginLeft="xsmall"
          className={styles.title}
        >
          {__('Welcome Offer')}
        </Base>
      </Base>
      <Base tagName="p" margin="none" weight="semibold" color="white">
        {__(
          "Get your first .COM, the world's most popular domain at 1$ /1st year!",
        )}
      </Base>
      <Base tagName="p" margin="none" color="white">
        {__(
          'As a new customer you can get a welcome discount when searching for a .COM.',
        )}
      </Base>
    </Base>
  );
}

export default (React.memo<Props>(
  OfferBox,
  () => true,
): React.ComponentType<Props>);
